export default __webpack_public_path__ + "static/orange-first-a98bf14485f11678d7eb4cf43d66d414.svg";